export const defaultSelectedDate = () => {
    var fecha = new Date();
    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, '0');
    return `${year}${month}`;
};

export default {
    loading: {
        module: false
    },
    params: {
        year_month_from: defaultSelectedDate(),
        year_month_up: defaultSelectedDate(),
        account_id: null,
        contact_id: null,
        contact_type: null,
    },
    accounts: [],
    contacts_lite: [],
    contact_balance:[],
    ag_grid: {
        selectedTheme: 'ag-theme-balham'
    },
    params_contacts_lite: {
        only_active:true,
        filter: "",
        type: "is_customer",
        paginate: false
    },
    iconAcordion: "ti-angle-down",

};




// WEBPACK FOOTER //
// ./src/modules/contact-balance/state.js